import { apiBaseUrl } from '@/lib/api-client';

/**
 * Turning a stored image path into one a browser can actually load.
 *
 * The API returns media as a **relative** path — `/uploads/…` — because the
 * storage driver decides what the public base is (ADR-013), and a local driver
 * has no origin of its own. That path resolves against whatever origin is
 * showing it, which for this admin is not the API: in development Vite serves
 * it, and in production the admin is a static build that may sit on a
 * different host entirely. Both cases 404, which renders as a broken image.
 *
 * So anything not already absolute is resolved against the API's origin. The
 * storefront learned this the same way.
 */
export function mediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) return url;

  return `${apiBaseUrl().replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
}
